import React from "react";
import "./videoPlayer.css";

const YouTubePlayer = ({ videoUrl }) => {
  const getYouTubeId = (url) => {
    const match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=))([\w-]{11})/);
    return match ? match[1] : null;
  };

  const videoId = getYouTubeId(videoUrl);

  if (!videoId) {
    return <p className="error-message">⚠ Error: URL inválida</p>;
  }

  return (
    <div className="youtube-wrapper">
      <div className="youtube-container">
        <iframe
          className="youtube-iframe"
          src={`https://www.youtube.com/embed/${videoId}`}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};

export default YouTubePlayer;
